import { z } from 'zod';

export const GameModel = z.object({
    homePoints: z.number().default(0),
    guestPoints: z.number().default(0),
});
export type GameModel = z.infer<typeof GameModel>;